module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "device-grid__phone"
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', {
          staticClass: "device-grid__name"
        }, [_c('b', {
          staticClass: "badge badge--vertical-middle badge--left",
          class: {
            'badge--offline': !_vm.device.Online,
              'badge--online': _vm.device.Online
          }
        }), _vm._v(" "), _c('h2', _vm._g({
          staticClass: "title--general title--device-info"
        }, on), [(_vm.windowSize.width <= _vm.grid.sd) ? _c('span', [_vm._v(_vm._s(_vm._f("truncate")(_vm.device.DisplayName, 16, '...')))]) : (_vm.windowSize.width <= _vm.grid.xxs) ? _c('span', [_vm._v(_vm._s(_vm._f("truncate")(_vm.device.DisplayName, 13, '...')))]) : (_vm.windowSize.width <= _vm.grid.xs) ? _c('span', [_vm._v(_vm._s(_vm._f("truncate")(_vm.device.DisplayName, 15, '...')))]) : (_vm.windowSize.width <= _vm.grid.sm) ? _c('span', [_vm._v(_vm._s(_vm._f("truncate")(_vm.device.DisplayName, 14, '...')))]) : (_vm.windowSize.width <= _vm.grid.md) ? _c('span', [_vm._v(_vm._s(_vm._f("truncate")(_vm.device.DisplayName, 15, '...')))]) : (_vm.windowSize.width <= _vm.grid.lg) ? _c('span', [_vm._v(_vm._s(_vm._f("truncate")(_vm.device.DisplayName, 16, '...')))]) : (_vm.windowSize.width <= _vm.grid.xl) ? _c('span', [_vm._v(_vm._s(_vm._f("truncate")(_vm.device.DisplayName, 19, '...')))]) : _c('span', [_vm._v(_vm._s(_vm.device.DisplayName))])])])]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.device.DeviceBrand)))])]), _vm._v(" "), _c('div', {
    staticClass: "device-grid__screen",
    class: {
      'checked-device__screen': _vm.isDeviceSelected(_vm.device)
    }
  }, [_c('div', {
    staticClass: "device-grid__screen__phone phone phone--medium"
  }, [(_vm.device.LastConnected) ? _c('img', {
    directives: [{
      name: "view",
      rawName: "v-view.once",
      value: (_vm.refreshImage),
      expression: "refreshImage",
      modifiers: {
        "once": true
      }
    }],
    ref: "image",
    staticClass: "phone__screen",
    attrs: {
      "alt": ""
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.redirectToDevice(_vm.device)
      },
      "load": _vm.onImageLoaded,
      "error": _vm.onImageError
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "device-grid__info"
  }, [_c('h2', {
    staticClass: "device-grid__info-row device-grid__info-row--grey title--general title--device-info"
  }, [_vm._v("\n\t\t\tLast updated\n\t\t")]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": !_vm.showTooltip
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('h2', _vm._g({
          staticClass: "device-grid__info-row title--general title--device-info"
        }, on), [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("formatDate")(_vm.lastSeen)) + "\n\t\t\t\t")])]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lastSeenTooltip))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24bdcac0","hasScoped":false}!./app/components/phone/template.html
// module id = 376
// module chunks = 0